const Statuses = ["Pending", "Approved", "Declined", "Overdue"];

const getStatuses = amt => {
  return [...Array(amt).keys()].map(
    n => Statuses[Math.floor(Math.random() * Statuses.length)]
  );
};

export { Statuses, getStatuses };
